export default __webpack_public_path__ + "static/media/postgresql.efd82540.svg";